//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios, { CancelToken } from "axios";

export default {
  components: {},
  props: {
    eff: Number,
    defect: Number,
    vdata: Array,
    target: Number,
    actual: Number,
  },
  data() {
    return {
      vdata2: [],
      filter_by: null,
      filter_txt: null,
      loading: false,
      thumbStyle: {
        right: "2px",
        borderRadius: "0px",
        backgroundColor: "#027be3",
        width: "2px",
        opacity: 0.75,
      },

      barStyle: {
        right: "2px",
        borderRadius: "0px",
        backgroundColor: "#027be3",
        width: "2px",
        opacity: 0.2,
      },
      pagination: {
        rowsPerPage: 0,
      },
      columns: [{
          name: "RNK",
          label: "Seq.",
          field: "RNK",
          sortable: false,
          align: "center",
        },
        {
          name: "MC_LINE",
          label: "Line",
          field: "MC_LINE",
          sortable: false,
          align: "center",
        },
        {
          name: "SO_NO_DOC",
          label: "SO",
          field: "SO_NO_DOC",
          sortable: false,
          align: "center",
        },

        {
          name: "TARGET",
          label: "Accu. Target (SM2)",
          field: "TARGET",
          sortable: false,
          align: "right",
        },
        {
          name: "ACTUAL_SCAN_IN",
          label: "Accu. Scan In",
          field: "ACTUAL_SCAN_IN",
          sortable: false,
          align: "right",
        },
        {
          name: "ACTUAL_SCAN_OUT",
          label: "Accu. Scan Out",
          field: "ACTUAL_SCAN_OUT",
          sortable: false,
          align: "right",
        },

        {
          name: "WIP_DAY",
          label: "WIP SM3 Day(s)",
          field: "WIP_DAY",
          sortable: true,
          align: "right",
          sort: (a, b) => parseFloat(a, 10) - parseFloat(b, 10),
        },
        {
          name: "STEP_NAME",
          label: "",
          field: "STEP_NAME",
          sortable: false,
          align: "center",
        },
      ],
    };
  },
  mounted() {
    console.log("mounted");
    setTimeout(() => {
      this.vdata2 = this.vdata;
    }, 3000);
  },
  watch: {
    filter_by: function (newValue, oldValue) {
      this.filterItems();
    },
    filter_txt: function (newValue, oldValue) {
      this.filterItems();
    },
  },
  methods: {
    getClassSize() {
      if (this.$q.screen.width <= 1440) {
        return "text-h4 fnt";
      } else {
        return "text-h3 fnt";
      }
    },
    getClassSize2() {
      if (this.$q.screen.width <= 1440) {
        return "text-h5 fnt";
      } else {
        return "text-h4 fnt";
      }
    },
    filterItems() {
      let filter_by = this.filter_by || "";
      let filter_txt = this.filter_txt || "";
      if (filter_txt != "") {
        this.loading = true;
        var filter_data = this.vdata.filter(function (el) {
          if (filter_by == "LINE") {
            return el.MC_LINE.includes(filter_txt);
          } else if (filter_by == "SO") {
            return el.SO_NO_DOC.includes(filter_txt);
          } else {
            return el;
          }
        });
        this.vdata2 = filter_data;
        this.loading = false;
      }
    },
  },
};
